import React from 'react';
import { Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AnalyticsDemoOverlayProps {
  isDemo: boolean;
  children: React.ReactNode;
}

export default function AnalyticsDemoOverlay({ isDemo, children }: AnalyticsDemoOverlayProps) {
  const navigate = useNavigate();

  if (!isDemo) return <>{children}</>;

  return (
    <div className={`demo-blur-wrapper${isDemo ? ' demo-blur-wrapper--active' : ''}`}>
      {children}
      <div className="demo-overlay-bg" />
      <div className="demo-overlay-card">
        <div className="demo-overlay-card__icon">
          <Lock size={32} />
        </div>
        <h3 className="demo-overlay-card__title">Unlock Analytics</h3>
        <p className="demo-overlay-card__text">
          Upgrade to a paid plan to see your real job search analytics and track your progress.
        </p>
        <button
          className="demo-overlay-card__btn"
          onClick={() => navigate('/settings/plan/purchase')}
        >
          Upgrade to Pro
        </button>
      </div>
    </div>
  );
}
